import gql from 'graphql-tag';

export const UPDATE_SOCIAL_ACCOUNT_EMAILS_MUTATION = gql`
  mutation UpdateSocialAccountEmailsMutation($socialAccountIds: [Float!]!, $network: String!) {
    socialAccountEmails: updateSocialAccountEmails(socialAccountIds: $socialAccountIds, network: $network)
  }
`;
